<template>

    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 36 36" style="enable-background:new 0 0 36 36;" :width="width" :height="height" xml:space="preserve">
            <path class="svg-outline-color"  d="M18,0c9.9,0,18,8.1,18,18s-8.1,18-18,18S0,27.9,0,18S8.1,0,18,0z M18,35c9.4,0,17-7.6,17-17S27.4,1,18,1
        S1,8.6,1,18S8.6,35,18,35z"/>
            <path class="svg-secondary-color"  d="M31,14.4L29.6,13c-0.4-0.4-1-0.4-1.4,0L27,14.2V10c0-1.1-0.9-2-2-2H10c-1.1,0-2,0.9-2,2v16c0,1.1,0.9,2,2,2h4h1
        h5h1h4c1.1,0,2-0.9,2-2v-6.2l4-4C31.4,15.4,31.4,14.8,31,14.4z M19,22.2V23h-4v-3h5v1.2L19,22.2z M14,19H9v-3h5V19z M15,16h5v3h-5
        V16z M14,20v3H9v-3H14z M22.2,19H21v-3h4.2L22.2,19z M10,9h15c0.6,0,1,0.4,1,1v5h-5h-1h-5h-1H9v-5C9,9.4,9.4,9,10,9z M10,27
        c-0.6,0-1-0.4-1-1v-2h5v3H10z M15,27v-3h4v1h1v2H15z M25,27h-4v-2h0.8l1-1H26v2C26,26.6,25.5,27,25,27z M26,23h-2.2l2.2-2.2V23z
         M21.4,24H20v-1.4l6.8-6.8l1.4,1.4L21.4,24z"/>
    </svg>

</template>

<script>
export default {
    name: "settingsIcon",
    props: {
        width: {
            type: Number,
            default: 40
        },
        height: {
            type: Number,
            default: 40
        }
    }
}
</script>

<style scoped lang="scss">
    .st1 {
        fill: $color-svg-fill;
    }
</style>



// WEBPACK FOOTER //
// src/common/components/svg/shared/vitalParametersIcon.vue